var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toolbar"},[_c('div',{staticClass:"container-toolbar"},[_c('div',{staticClass:"actions"},[_vm._t("actions")],2),_c('div',{staticClass:"actions-second"},[_vm._t("actions-second")],2)]),_c('div',{staticClass:"search"},[_vm._t("simpleSearch")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }